import { useRouteRef } from '@backstage/core-plugin-api';
import { Navigate } from 'react-router-dom';
import { activityCreationRouteRef } from '../routes';

export const ControlPlaneCreationPage = () => {
  const activityCreationRoute = useRouteRef(activityCreationRouteRef);
  return <Navigate to={activityCreationRoute()} replace />;
};
